module.exports = {
	"articleTitle1": "Conference ignites with civil rights rally on Diag",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Grange Kitchen & Bar",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/content/eating-local-when-fields-freeze-over",
	"articleSnippet1": "Feb 11, 2002 ... I do support their ultimate goals to keep the door open to higher education,\" said \nNorman Grange, an administrator from Lewis Cass Technical ...",
	"articleSnippet2": "Oct 14, 2009 ... With the clink of artisan martinis and the pang of steep menu prices, it's clear that \nGrange Kitchen and Bar on Liberty Street has joined the ...",
	"foodRecommendations": [],
	"articleTitle2": "Eating local when the fields freeze over",
	"address": "118 W Liberty St, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.279749,
		"lng": -83.749541
	},
	"totalMisc": 0,
	"categories": {
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/grange.json
// module id = 884
// module chunks = 0